import e from "@dialpad/dialtone-tokens/layered/themes/tokens-rust-harbor-colors.css?inline";
//#region themes/rust-harbor.js
var t = {
	brand: {
		css: e,
		name: "rust-harbor"
	},
	material: { name: "graphite" }
};
//#endregion
export { t as default };
